import UserService from "services/User.service";

const profileConfig = {
  // logout
  "casdoor/UserService/.logoutUser": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.logoutUser(token, params);
    },
    mockSelector: "profile.logoutUser",
  },
  // delete user account
  "casdoor/UserService/.deleteUserAccount": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.deleteUserAccount(params, token);
    },
    mockSelector: "profile.deleteUserAccount",
  },
  // get user setting
  "casdoor/UserService/.getUserSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: false,
    handler: async (service, params) => {
      const { orgId, userName } = params;
      return await service.getUserSetting(orgId, userName);
    },
    action: null,
    mockSelector: "profile.getUserSetting",
  },
  // update user setting
  "casdoor/UserService/.updateUserSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.updateUserSetting(params.orgId, params.userName, params.param, token);
    },
    mockSelector: "profile.updateUserSetting",
  },
  // check pw
  "casdoor/UserService/.checkUserPassword": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.checkUserPassword(params, token);
    },
    mockSelector: "profile.checkUserPassword",
  },
  // update pw
  "casdoor/UserService/.updateUserPassword": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.updateUserPassword(params, token);
    },
    mockSelector: "profile.updateUserPassword",
  },
  // init MFA
  "casdoor/UserService/.initMfaSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.initMfaSetting(params, token);
    },
    mockSelector: "profile.initMfaSetting",
  },
  // MFA send verify mail
  "casdoor/UserService/.sendVerifyMail": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.sendVerifyMail(params, token);
    },
    mockSelector: "profile.sendVerifyMail",
  },
  // MFA verify
  "casdoor/UserService/.verifyMfaSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.verifyMfaSetting(params, token);
    },
    mockSelector: "profile.verifyMfaSetting",
  },
  // MFA enable finally
  "casdoor/UserService/.enableMfaSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.enableMfaSetting(params, token);
    },
    mockSelector: "profile.enableMfaSetting",
  },
  // select prefer MFA
  "casdoor/UserService/.preferMfaSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.preferMfaSetting(params, token);
    },
    mockSelector: "profile.preferMfaSetting",
  },
  // delete MFA (all)
  "casdoor/UserService/.deleteMfaSetting": {
    protocol: "https",
    service: UserService,
    method: "casdoor",
    token: true,
    handler: async (service, params, token) => {
      return await service.deleteMfaSetting(params, token);
    },
    mockSelector: "profile.deleteMfaSetting",
  },
};

export default profileConfig;
